import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import SiteLayout from '../Shared/SiteLayout';
import DataContainer from '../Shared/DataContainer';
import LoadingButton from '../Shared/LoadingButton';
import TextInput from '../Shared/TextInput';
import { can } from '../utils';

const ProceedCart = () => {
     const { auth, app, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          cart: (data.cart)?data.cart.id:0,
          details: (data.cart)?data.cart.details:[],
          pay_method: '',
          pickup: '',
          email: ''
     });

     function handleChange(e, index) {
          e.persist();
          const value = e.target.value;
          const key = e.target.name;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          if(values.pay_method != ''){
               setSending(true);
               let link = auth.user?'payment.prepare':'site.payment.prepare';
               Inertia.post(route('payment.prepare', data.cart.id), values).then(() => {
                    setSending(false);
               });
          }
     }

     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>Procéder au Paiement</title>
               </Helmet>
               <div className="max-w-7xl mt-10">
                    <h1 className="font-bold text-center text-4xl uppercase text-emerald-800">Procéder au Paiement</h1>
               </div>
               <section className="w-full pt-10 pb-10 bg-white">
                    <div className="container mx-auto">
                         {!data.cart && (<div className="col-span-12 bg-blue-100 text-blue-600 border border-blue-500 px-4 py-4 text-center">Votre panier est actuellement vide. <InertiaLink className="font-bold" href={route('site.product.category', 'Librairie')}>Retour à la boutique</InertiaLink>.</div>)}
                         {data.cart && (<div className="flex justify-center my-6">
                              <div className="flex flex-col w-full p-8 text-gray-800 bg-white shadow-lg pin-r pin-y md:w-4/5 lg:w-4/5">
                                   <form onSubmit={handleSubmit}>
                                        <div className="flex-1">
                                             <table className="w-full text-sm lg:text-base" cellSpacing="0">
                                                  <thead>
                                                       <tr className="h-12 uppercase">
                                                            <th className="hidden md:table-cell"></th>
                                                            <th className="text-left">Produit</th>
                                                            <th className="lg:text-right text-left pl-5 lg:pl-0">
                                                                 <span className="lg:hidden" title="Quantity">Qté</span>
                                                                 <span className="hidden lg:inline">Quantité</span>
                                                            </th>
                                                            <th className="hidden text-right md:table-cell">Prix</th>
                                                            <th className="text-right">Prix Total</th>
                                                       </tr>
                                                  </thead>
                                                  <tbody>
                                                       {values.details.map(({id, name, code, product, quantity, currency, price, packs, image, update}, i) => {
                                                            return <tr className="pt-4 border-b border-gray-300" key={id}>
                                                                 <td className="hidden pb-4 md:table-cell">
                                                                      <a href="#">
                                                                           {image && (<img src={image} alt={name} className="w-20 rounded" alt="Thumbnail" />)}
                                                                           {!image && (<img className="w-20" src={`https://ui-avatars.com/api/?name=${name}&amp;color=7F9CF5&amp;background=EBF4FF`} alt={name} />)}
                                                                      </a>
                                                                 </td>
                                                                 <td>
                                                                      <a href="#">
                                                                           <p className="mb-2 md:ml-4">{name} <span className="text-xs text-gray-500">({code})</span></p>
                                                                           {packs && (<span className="ml-4 text-xs text-gray-600">{packs.join(' | ')}</span>)}
                                                                      </a>
                                                                 </td>
                                                                 <td className="justify-center md:justify-end md:flex mt-6">
                                                                      <div className="w-20">
                                                                           <div className="relative flex flex-row w-full h-8">
                                                                                <input type="number" onChange={(e)=>handleChange(e, i)} value={quantity} className="w-full font-semibold text-center text-gray-700 bg-gray-200 outline-none focus:outline-none hover:text-black focus:text-black" readOnly />
                                                                           </div>
                                                                      </div>
                                                                 </td>
                                                                 <td className="hidden text-right md:table-cell">
                                                                      <span className="text-sm lg:text-base font-medium">{currency} {price.toFixed(2)}</span>
                                                                 </td>
                                                                 <td className="text-right">
                                                                      <span className="text-sm lg:text-base font-medium">{currency} {(price * quantity).toFixed(2)}</span>
                                                                 </td>
                                                            </tr>
                                                       })}
                                                  </tbody>
                                             </table>
                                             <hr />
                                             <div className="my-4 mt-6 -mx-2 lg:flex">
                                                  <div className="lg:px-2 lg:w-1/2">
                                                  <div className="p-4">
                                                       <p className="mb-4 font-bold">Methode de Paiement</p>
                                                       <ul className="overflow-auto h-64 list-none pt-2 mt-2">
                                                            <li className={`p-2 mt-2 rounded hover:bg-gray-200 hover:shadow-md`} key={data.cart.pay_method.name}>
                                                                 <label className="flex items-center" htmlFor="moncash">
                                                                      <input name="pay_method" className="form-checkbox" type="radio" value={data.cart.pay_method.name} onChange={handleChange}/>
                                                                      <span className="ml-2 text-sm text-gray-800">
                                                                           {!data.cart.pay_method.logo && (data.cart.pay_method.name)}
                                                                           {data.cart.pay_method.logo && (<img src={data.cart.pay_method.logo} alt={data.cart.pay_method.name} className="w-10" />)}
                                                                      </span>
                                                                      <span className="ml-2 text-md font-bold text-gray-700">{data.cart.pay_method.name}</span>
                                                                 </label>
                                                            </li>
                                                       </ul>
                                                  </div>
                                                  </div>
                                                  <div className="mt-4 float-right lg:px-2 lg:w-1/2">
                                                       {/*<div className="p-4 bg-gray-100 rounded-full">
                                                            <h1 className="ml-2 font-bold uppercase">Order Details</h1>
                                                       </div>*/}
                                                       <div className="p-4">
                                                            <div className="flex justify-between border-b">
                                                                 <div className="lg:px-4 lg:py-2 m-2 text-lg lg:text-xl font-bold text-center text-gray-800">
                                                                      Total
                                                                 </div>
                                                                 <div className="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center text-gray-900">
                                                                      {data.cart.currency} {data.cart.amount.toFixed(2)}
                                                                 </div>
                                                            </div>
                                                            {/*<div className="flex justify-between pt-4 border-b">
                                                                 <div className="lg:px-4 lg:py-2 m-2 text-lg lg:text-xl font-bold text-center text-gray-800">
                                                                      Tax
                                                                 </div>
                                                                 <div className="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center text-gray-900">
                                                                      2,976.55€
                                                                 </div>
                                                            </div>
                                                            <div className="flex justify-between pt-4 border-b">
                                                                 <div className="lg:px-4 lg:py-2 m-2 text-lg lg:text-xl font-bold text-center text-gray-800">
                                                                      Total
                                                                 </div>
                                                                 <div className="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center text-gray-900">
                                                                      17,859.3€
                                                                 </div>
                                                            </div>*/}
                                                            <LoadingButton type="submit" loading={sending} className={`flex justify-center w-full px-10 py-3 mt-6 font-medium text-white uppercase bg-emerald-700 rounded-full shadow item-center hover:bg-emerald-800 focus:shadow-outline focus:outline-none ${(values.pay_method == '')?'opacity-50 cursor-not-allowed':''}`}>
                                                                 Continuer
                                                            </LoadingButton>
                                                       </div>
                                                  </div>
                                             </div>
                                        </div>
                                   </form>
                              </div>
                         </div>)}
                    </div>
               </section>
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
ProceedCart.layout = page => <SiteLayout children={page} header={'Cart'} />;

export default ProceedCart;
